























import { Component, Vue, Prop ,Mixins } from 'vue-property-decorator'
import DropDown from '../mixins/Dropdown'

@Component
//搜索单层的筛选 包括亮点经验 等级 门店等筛选项
export default class SearchScreen extends  Mixins(DropDown) {

  @Prop({ default: () => ({ ID: '', NAME: '全城' }) }) readonly value: any
  @Prop({ default: [] }) readonly listData!: any //全部筛选项
 

}
